






































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Connector from '@vue-polkadot/vue-api';
import Router from 'vue-router';
import Card from '../shared/Card.vue';

@Component({
  components: {
    Card,
  },
})
export default class NodeDetails extends Vue {  
  private health: any = '';
  private peers: any = [];
  private peersAdjusted: any[] = [];
  private subs: any[] = [];
  private ourBestBlock: any = '';
  private interval: any = '';
  private columns: any = [
    {
      field: 'peerId',
      label: 'peerId',
      visible: true,
      width: '10',
    },
    {
      field: 'roles',
      label: 'role',
      width: '10',
      visible: true
    },
    {
      field: 'bestNumber',
      label: 'best block',
      visible: true,
    },
    {
      field: 'bestHash',
      label: 'best hash',
      width: '10',
      visible: false
    },
    {
      field: 'protocolVersion',
      label: 'protocol Version',
      width: '10',
      visible: false
    }
  ]
    
  public async loadExternalInfo() {
    const { api } = Connector.getInstance();
    this.peers = await api.rpc.system.peers();
    this.health = await api.rpc.system.health() 
    this.subs.push(await api.derive.chain.bestNumber((value: any) => this.ourBestBlock = value));
  }

  public async refreshPeers() {
    const { api } = Connector.getInstance();
    this.peers = await api.rpc.system.peers();
    console.log('refreshing peers table')
    // const arr = Object.entries(this.peers)

    // const a: any[] = []
    // for (const [key, value] of arr) {    
    //   a.push([key, (value as any)])
    // }

    // const m = new Map(a)
    
    // for (const o of m) {
    //   this.peersAdjusted.push(o[1])
    // }
    // console.log('NodeDetails -> refreshPeers -> a', a);
  }

  public async mounted(): Promise<void> {
    this.loadExternalInfo();
    this.interval = setInterval(this.refreshPeers, 10000)
  }

  // Unsubscribe before destroying component
  public beforeDestroy() {
    clearInterval(this.interval)
    this.subs.forEach((sub) => sub());
  }
}
